export type GetCustomerRatingsAndReviewPageUrlProps = {
  productId: string;
  filterTags?: string[];
  searchParams?: URLSearchParams;
  variationId?: string;
  page?: string;
};

/* 
    getCustomerRatingsAndReviewsPageUrl
    a method to get a valid customer ratings and reviews page URLSearchParams
    you can pass all needed parts by PageProps

    @params productId - the productId of the product (akl or slug param -> RSC by params and RCC by useParams hook)
    @params filterTags - the filter tags (ftag param -> RSC by params and RCC by useParams hook)
    @params searchParams - the URLSearchparams  (RSC by searchParams and getURLSearchParamsFromPagePropsSearchParams helper function and RCC by useSearchParams hook)
    @params variationId - the variationId of the product (currently the sku -> will be added to the URL search params)
    @params page - the page of the rating page (will be added to the URL search params)
  */
export const getCustomerRatingsAndReviewsPageUrl = ({
  productId,
  filterTags,
  searchParams,
  variationId,
  page,
}: GetCustomerRatingsAndReviewPageUrlProps) => {
  const newSearchParams = new URLSearchParams(searchParams);
  if (variationId) {
    newSearchParams.set('sku', variationId);
  }
  if (page) {
    newSearchParams.set('page', page);
  }
  return `/p/${productId}/rating${filterTags ? `/${filterTags.join('/')}` : ''}${newSearchParams.size ? `?${newSearchParams}` : ''}`;
};
